import styled from '@emotion/styled'

import { css } from '@emotion/react'

const Container = styled.section`
  & {
    position: relative;
    width: 100%;
  }

  .container {
    width: ${({ theme }) => theme.size.width[90]};
    max-width: ${({ theme }) => theme.size.width[900]};
    height: auto;
    padding: 178px 0;
    margin: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-flow: column nowrap;
  }

  .decorator-container {
    overflow: visible;
  }

  #group-43 {
    position: absolute;
    right: 0;
    top: 0;
    height: 20vw;
    max-height: 268px;
    transform: translate3d(-5vw, -50%, 0);
    overflow: visible;
    transform-origin: top right;
  }

  #group-44 {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 20vw;
    max-height: 344px;
    transform: translate3d(40%, 50%, 0);
    overflow: visible;
  }

  #group-379 {
    position: absolute;
    top: 0;
    left: 0;
    height: 30vw;
    max-height: 300px;
    transform: translate3d(0%, -42%, 0);
    overflow: visible;
    transform-origin: bottom right;
  }

  .grid-container {
    display: grid;
    grid-gap: 24px;
    margin: 0 0 14px 0;
  }

  .all-blog {
    width: 256px;
    font-size: var(--fs-500);
    cursor: pointer;
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '.container': {
          padding: [
            '96px 0 96px 0',
            '98px 0 134px 0',
            '141px 0 134px 0',
            '164px 0 178px 0',
          ],
        },
        '.grid-container': {
          gridTemplateColumns: [
            'repeat(1, 1fr)',
            'repeat(1, 1fr)',
            'repeat(2, 1fr)',
            'repeat(4, 1fr)',
          ],
        },
        '#group-43': {
          transform: [
            'translate3d(0, 40%, 0) rotate(90deg)',
            'translate3d(0, 40%, 0) rotate(90deg)',
            'translate3d(0, 40%, 0) rotate(90deg)',
            'translate3d(-5vw, -60%, 0)',
          ],
          height: ['40vw', '40vw', '30vw', '20vw'],
        },
        '#group-44': {
          height: ['26vw', '26vw', '14vw'],
        },
        '#group-379': {
          transform: [
            'translate3d(-100%, 0%, 0) rotate(90deg)',
            'translate3d(-100%, 0%, 0) rotate(90deg)',
            'translate3d(-100%, 0%, 0) rotate(90deg)',
            'translate3d(-10%, -42%, 0)',
            'translate3d(0%, -42%, 0)',
          ],
          top: ['unset', 'unset', 'unset', '0'],
          bottom: ['0', '0', '0', 'unset'],
        },
      }),
    ).styles}}
`

export default Container
